<template>
  <v-dialog v-model="dialog" persistent max-width="1600px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Stanica</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="9">
                <v-text-field
                  label="Stanica"
                  v-model="stanica.Stanica"
                  maxlength="255"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Indikatív"
                  v-model="stanica.Indik"
                  maxlength="255"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Poznámka"
                  v-model="stanica.Poznamka"
                  rows="3"
                ></v-textarea>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="X"
                  type="number"
                  v-model.number="stanica.X"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Y"
                  type="number"
                  v-model.number="stanica.Y"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Z"
                  type="number"
                  v-model.number="stanica.Z"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-container class="grey lighten-5">
                  <v-row no-gutters>
                    <v-col v-for="lok in lokality" :key="lok.ID" cols="3">
                      <v-checkbox
                        v-model="stanica.LokalityIds"
                        :label="lok.Name"
                        :value="lok.ID"
                        class="ma-0 pa-0"
                        dense
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="alert"
            text
            @click="deleteStanica()"
            v-if="stanica.ID !== 0"
            >Vymazať</v-btn
          >
          <v-btn color="primary" text @click="dialog = false">Zavrieť</v-btn>
          <v-btn color="primary" text @click="save()">Uložiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import * as Miscella from "../plugins/miscella.js"

export default {
  name: "StanicaDetail",
  components: {},
  data: () => ({
    dialog: false,
    stanica: { ID: 0 },
    oldid: "",
    valid: true,
    lokality: []
  }),
  computed: {
    isNew: function() {
      let ret = true
      if (Miscella.isSet(this.stanica)) {
        if (this.stanica.ID > 0) {
          ret = false
        }
      }
      return ret
    }
  },
  methods: {
    show: function(s) {
      this.dialog = true
      this.stanica = Miscella.deepCloneObject(s)
      this.oldid = s.ID
      this.readLokality()
      console.log("EDIT STANICA", s)
    },
    save: async function() {
      if (this.$refs.form.validate()) {
        try {
          console.log("SAVE STANICA", this.stanica)
          let response = await this.$axios.post("/r/stanica", {
            oldID: this.oldid,
            stanica: this.stanica,
            lokalityIds: this.stanica.LokalityIds
          })
          if (response.status === 200) {
            this.$store.commit("message", "Stanica uložená")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    },
    readLokality: async function() {
      try {
        let response = await this.$axios.get("/r/lokality")
        if (response.status === 200) {
          this.lokality = response.data
          this.lokality.sort(function(a, b) {
            if (a.Name < b.Name) {
              return -1
            } else if (a.Name > b.Name) {
              return 1
            }
            return 0
          })
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    deleteStanica: async function() {
      if (confirm("Naozaj vymazať stanicu z databázy ?")) {
        try {
          let response = await this.$axios.delete(
            "/r/stanica/" + this.stanica.ID
          )
          if (response.status === 200) {
            this.$store.commit("message", "Stanica je vymazaná.")
            this.dialog = false
            this.$emit("delete")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    }
  }
}
</script>
